import { Outlet } from "react-router-dom";
import {
  Navbar,
  SmallSidebar,
  BigSidebar,
  DeleteConfirmation,
  Alert,
  Loading,
  InternetConnectionChecker,
} from "../../components";
import Wrapper from "../../assets/wrappers/SharedLayout";

const SharedLayout = () => {
  return (
    <Wrapper>
      <main className="dashboard">
        <SmallSidebar />
        <BigSidebar />
        <DeleteConfirmation />
        <div>
          <Navbar />
          <div className="dashboard-page">
            <InternetConnectionChecker />
            <Loading />
            <Alert />
            <Outlet />
          </div>
        </div>
      </main>
    </Wrapper>
  );
};

export default SharedLayout;
